<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

import ChangeActivity from './ChangeActivity.vue';

const props = defineProps({
  messages: {
    type: Array,
    required: true,
  },
  previewVersion: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['togglePreview']);

const { t } = useI18n();
const { formatMessage } = useMessageFormatter();

const latestVersion = computed(() => {
  const versions = props.messages
    .map(({ content }) => content?.version)
    .filter(Boolean);
  return versions[versions.length - 1];
});

const togglePreview = version => {
  emit('togglePreview', version);
};
</script>

<template>
  <ul class="w-full">
    <li
      v-for="message in messages"
      :key="message.id"
      class="mb-4 max-w-full block"
    >
      <div v-if="message.role === 'llm'" class="flex justify-start">
        <div
          v-dompurify-html="formatMessage(message.content)"
          class="prose prose-bubble bg-white dark:bg-n-solid-3 rounded-xl p-3 shadow max-w-[70%] text-sm ltr:rounded-bl-sm rtl:rounded-br-sm"
        />
      </div>
      <div v-else-if="message.role === 'user'" class="flex justify-end">
        <div
          class="bg-n-brand text-white rounded-xl p-3 shadow max-w-[70%] text-sm ltr:rounded-br-sm rtl:rounded-bl-sm"
        >
          {{ message.content }}
        </div>
      </div>

      <ChangeActivity
        v-else-if="message.role === 'activity'"
        :label="
          t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.MESSAGES.ACTIVITY.VERSION', {
            version: message.content?.version,
          })
        "
        :message="message"
        :is-active="
          previewVersion?.id === message.id ||
          (!previewVersion && message.content?.version === latestVersion)
        "
        :is-disabled="message.content?.version === latestVersion"
        @click="togglePreview(message)"
      />
    </li>
  </ul>
</template>
